<template>
  <div class="header-navigation">
    <div class="header-content">
      <div class="back-button-wrapper">
        <BackButton class="header-back-button" />
      </div>
      <div class="title-wrapper">
        {{ selectedCategoryTitle }}
      </div>
      <div class="menu-button-wrapper">
        <CategoryMenu :menu-items="menuItems" :selected-category="currentCategory" />
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'
import CategoryMenu from './CategoryMenu.vue'

export default {
  name: 'HeaderNavigation',
  components: {
    BackButton,
    CategoryMenu
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    selectedCategoryTitle: {
      type: String,
      default: null
    }
  },
  computed: {
    currentTree() {
      return this.$store.state.currentTreeLocation
    },
    itemsByCategoriesNew() {
      return this.$store.state.itemsByCategories
    },
    showLandingPage() {
      return this.$store.state.showLandingPage
    },
    currentCategory() {
      if (this.currentTree && this.currentTree.length && this.itemsByCategoriesNew) {
        return this.currentTree[this.currentTree.length - 1];
      }
      return null;
    },
    categoryTitle() {     
      if (this.currentTree && this.currentTree.length && this.itemsByCategoriesNew) {
        const currentCategory = this.itemsByCategoriesNew[this.currentCategory];
        
        if (currentCategory) {
          return currentCategory.name;
        }
      }
      return "";
    }
  }
}
</script>

<style scoped>
.header-navigation {
  width: 100%;
  position: sticky;
  top: 80px; /* Match the app-header height */
  background-color: white;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin: 0;
  padding: 0;
  z-index: 2; /* Keep it above content but below app header */
}

.header-content {
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
}

.back-button-wrapper {
  min-width: 56px;
}

.header-back-button {
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-wrapper {
  flex: 1;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-button-wrapper {
  min-width: 56px;
  position: relative;
  z-index: 3; /* Keep menu button above the header navigation */
}
</style> 